export default (state, products_type, product_id) => {
  const correct_product_index = state[`${products_type}_products`].findIndex(({ id }) => id === product_id)

  return state[`${products_type}_products`][correct_product_index]
}